import { cn } from "@faire/prototype-playground/lib/utils";

import { VariantGroup } from "../types";

/**
 * Settings flyout — its own top-level toolbar panel for a prototype's UI-option
 * knobs (grid gutters, type/header treatments, etc.), kept separate from the
 * Variants panel so the scenario/segment stack stays short. Reuses the
 * VariantGroup shape; selections drive `group.onChange` (the prototype owns
 * persistence), so this panel stays decoupled from the variants/states URL params.
 */
export const SettingsPanel: React.FC<{ settingsGroups: VariantGroup[] }> = ({
  settingsGroups,
}) => (
  <div className="w-64 rounded-xl border border-[#2a2a2a] bg-[#141414] shadow-[0_2px_8px_rgba(0,0,0,0.25)]">
    <div className="border-b border-[#2a2a2a] px-3 py-2">
      <span className="text-[11px] font-medium text-[#aaa]">Settings</span>
    </div>
    {settingsGroups.length > 0 ? (
      <div className="space-y-4 p-3">
        {settingsGroups.map((group) => (
          <div key={group.queryKey ?? group.title}>
            <div className="mb-1.5 text-[10px] font-medium tracking-wide text-[#aaa] uppercase">
              {group.title}
            </div>
            <div className="space-y-0.5">
              {group.variants.map((variant) => {
                const isActive = variant.variantNumber === group.active;
                return (
                  <button
                    key={variant.variantNumber}
                    onClick={() => group.onChange(variant.variantNumber)}
                    className={cn(
                      "flex w-full items-center gap-2 rounded-lg px-2.5 py-1.5 text-left text-[12px] transition-colors",
                      isActive
                        ? "text-fs-text-primary-inverse bg-[#7B9EFF]/10 font-medium"
                        : "text-[#ddd] hover:bg-[#1f1f1f]"
                    )}
                  >
                    <span
                      className={cn(
                        "inline-block h-1.5 w-1.5 flex-shrink-0 rounded-full",
                        isActive ? "bg-[#7B9EFF]" : "bg-[#555]"
                      )}
                    />
                    {variant.label}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    ) : (
      <div className="p-4">
        <p className="text-[12px] text-[#aaa]">No settings.</p>
      </div>
    )}
  </div>
);
